import { Method, send } from "./MyHttp";

/**
 * 리스트
 */
export const GetList = (params, success, fail) => {
    let paramsT = { ...params };

    send(Method.GET, "/push/all", paramsT, success, fail);
};

export const GetListRead = (params, success, fail) => {
    let paramsT = { ...params };

    send(Method.GET, "/push/read", paramsT, success, fail);
};

export const Delete = (params, success, fail) => {
    let paramsT = { ...params };

    send(Method.DELETE, "/push", paramsT, success, fail);
};
